import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers';
import { enGB, es } from 'date-fns/locale';
import { CustomDay } from '../CustomDay';
import { WorkoutsByDate } from '../../../types';

interface WorkoutCalendarProps {
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  calendarMonth: Date;
  setCalendarMonth: (date: Date) => void;
  workouts: WorkoutsByDate;
  workoutDays: Set<string>;
  bodyWeightDays: Set<string>;
  programDays: Set<string>;
  inProgressDate?: string | null;
  language: string;
}

export const WorkoutCalendar: React.FC<WorkoutCalendarProps> = ({
  selectedDate,
  setSelectedDate,
  calendarMonth,
  setCalendarMonth,
  workouts,
  workoutDays,
  bodyWeightDays,
  programDays,
  inProgressDate,
  language,
}) => {
  const dateLocale = language === 'es' ? es : enGB;

  const renderCustomDay = (day: Date, selectedDates: Array<Date | null>, pickersDayProps: any) => {
    return <CustomDay {...pickersDayProps} day={day} workouts={workouts} workoutDays={workoutDays} bodyWeightDays={bodyWeightDays} programDays={programDays} inProgressDate={inProgressDate} />;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateLocale}>
      <DateCalendar
        value={selectedDate}
        onChange={setSelectedDate}
        onMonthChange={(date) => setCalendarMonth(date)}
        slots={{ day: (props) => renderCustomDay(props.day, [], props) }}
        sx={{
          '& .MuiDayCalendar-header': {
            '& .MuiTypography-root': {
              width: 44,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }
          }
        }}
      />
    </LocalizationProvider>
  );
};
